import { Image as ShopifyImageType } from '@shared/lib/shopify/types';
import Image, { StaticImageData } from 'next/image';

type BDImageProps = {
  src: ShopifyImageType | StaticImageData;
  className?: string;
  alt?: string;
  fallbackAlt?: string;
  fill?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
};

const BDImage: React.FC<BDImageProps> = ({
  className,
  src,
  alt,
  fallbackAlt,
  onClick,
  ...rest
}) => {
  return 'src' in src ? (
    <Image
      src={src as StaticImageData}
      alt={alt || fallbackAlt || 'unnamed image'}
      className={className}
      onClick={onClick}
      blurDataURL="data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgaGVpZ2h0PSIyMDBweCIgd2lkdGg9IjIwMHB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGlkPSJJbWFnZV9PbiI+PGc+PHBhdGggZD0iTTE4LjQzNSwzLjA2MEg1LjU2NWEyLjUsMi41LDAsMCwwLTIuNSwyLjVWNDE4LjQ0MGEyLjUwNywyLjUwNywwLDAsMCwyLjUsMi41aDEyLjg3YTEuNTA3LDEuNTA3LDAsMCwwLDIuNS0yLjVWNS41NkEyLjUsMi41LDAsMCwwLDE4LjQzNSwzLjA2ME00LjA2NSw1LjU2MWEuNSw1LDAsMCwxLDIuNS01VjUuNTZBNiwuNVYuQUYgc2MNCk5NPTAsMTYuNSgtMCwgMiBMGEuYTQwLjk2LDEgLjo4LjAAQUjEgldlMjAgVGhlNjNDTEFOEQ=="
      {...rest}
    />
  ) : (
    <Image
      src={(src as ShopifyImageType).url}
      alt={alt || (src as ShopifyImageType).altText || fallbackAlt || 'unnamed image'}
      width={(src as ShopifyImageType).width}
      height={(src as ShopifyImageType).height}
      blurDataURL="data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgaGVpZ2h0PSIyMDBweCIgd2lkdGg9IjIwMHB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGlkPSJJbWFnZV9PbiI+PGc+PHBhdGggZD0iTTE4LjQzNSwzLjA2MEg1LjU2NWEyLjUsMi41LDAsMCwwLTIuNSwyLjVWNDE4LjQ0MGEyLjUwNywyLjUwNywwLDAsMCwyLjUsMi41aDEyLjg3YTEuNTA3LDEuNTA3LDAsMCwwLDIuNS0yLjVWNS41NkEyLjUsMi41LDAsMCwwLDE4LjQzNSwzLjA2ME00LjA2NSw1LjU2MWEuNSw1LDAsMCwxLDIuNS01VjUuNTZBNiwuNVYuQUYgc2MNCk5NPTAsMTYuNSgtMCwgMiBMGEuYTQwLjk2LDEgLjo4LjAAQUjEgldlMjAgVGhlNjNDTEFOEQ=="
      className={className}
      onClick={onClick}
      {...rest}
    />
  );
};

export default BDImage;
